import { Box, alpha, styled } from "@mui/material"
import type { GoalProgressState } from "../getGoalProgress"

type MissionProgressBarProps = {
  missionCount: number
} & Pick<GoalProgressState, "goals" | "maxGoals">

const toPercentage = (value: number, total: number) =>
  total === 0 ? 0 : (value * 100) / total

export const MissionProgressBar = ({
  goals,
  maxGoals,
  missionCount,
}: MissionProgressBarProps) => {
  const scaleMax = Math.max(missionCount, maxGoals)
  const missionCountPercent = toPercentage(missionCount, scaleMax)
  return (
    <ProgressBarContainer>
      <Box width={"100%"} height={"100%"} position={"relative"}>
        <ProgressBar width={`${missionCountPercent}%`} />
        {goals.map(({ type, value }) => (
          <StepDot key={type} percent={toPercentage(value, scaleMax)} />
        ))}
      </Box>
    </ProgressBarContainer>
  )
}

const ProgressBarContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "27px",
  marginBottom: theme.spacing(1.5),
  backgroundColor: theme.palette.brandingAccent.light4,
  borderRadius: "30px",
  padding: theme.spacing(0.75, 0.625),
}))

const ProgressBar = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.branding.light4,
  height: "100%",
  borderRadius: "30px",
}))

const StepDot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "percent",
})<{ percent: number }>(({ theme: { palette }, percent }) => ({
  position: "absolute",
  top: 0,
  left: `${percent}%`,
  transform: `translateX(-${percent}%)`,
  backgroundColor: palette.common.white,
  height: "100%",
  aspectRatio: "1/1",
  borderRadius: "50%",
  boxShadow: `0 0 4px ${alpha(palette.common.black, 0.25)}`,
}))
